import React from 'react';
import { FaFacebookF, FaXTwitter, FaWhatsapp } from 'react-icons/fa6';
import { FaShareAlt } from "react-icons/fa";

const ShareButton = () => {
  return (
    <div className="bg-gray-100 py-3 px-4 flex items-center gap-3 rounded-md w-fit mx-auto mt-4 shadow-sm">
      <FaShareAlt className="text-gray-600" />
      <span className="font-semibold text-sm text-gray-800">Share on</span>

      <a href="#" className="bg-[#3b5998] text-white rounded-full p-2 hover:scale-105 transition">
        <FaFacebookF />
      </a>

      <a href="#" className="bg-white text-black border border-gray-300 rounded-full p-2 hover:scale-105 transition">
        <FaXTwitter />
      </a>

      <a href="#" className="bg-[#25D366] text-white rounded-full p-2 hover:scale-105 transition">
        <FaWhatsapp />
      </a>
    </div>
  );
};

export default ShareButton;
